import axios from "axios";
import { untouch } from "redux-form";
import forEach from "lodash/forEach";
import store from "../store";
import { loadValue, saveValue } from "../utils/poolTools";

import {
  CHANGE_POLL_PAGE,
  NEXT_POLL_PAGE,
  PREVIOUS_POLL_PAGE,
  CANCEL_CONFIRM_DIALOG,
  SEND_FORM,
  POLL_PROPERLY_SAVED,
  POLL_NOT_PROPERLY_SAVED,
  CLOSE_SAVE_ERROR_DIALOG
} from "./types";

export function changePollPage(page) {
  return {
    type: CHANGE_POLL_PAGE,
    page
  };
}
// sprawdzic, czy formularz wypelniony poprawnie
export function nextPollPage(values) {
  return dispatch => {
    // usuniuecie touch jest konieczne do tego, aby przy wejsciu na strone,
    // ktora ma bledy, a wczesniej byla odwiedzana nie pokazywala od razu
    // bledow walidacji

    // store.getState().poll.page zawiera
    const savedPage = loadValue("poll-form", "page") || 0;
    const realFormPage = store.getState().poll.page || 0;
    // console.log("saved page: " + savedPage);
    // console.log("real page: " + realFormPage);

    if (savedPage !== realFormPage) {
      saveValue("poll-form", "page", 0);
      window.location.reload();
    } else {
      forEach(store.getState().form.pollForm.fields, (vValue, vKey) => {
        dispatch(untouch("pollForm", vKey));
      });
      dispatch({ type: NEXT_POLL_PAGE, values });
    }

    window.scrollTo(0, 0);
  };
}
export function previousPollPage(values, history) {
  return dispatch => {
    // czyszczenie dla 1 strony i cofniecia
    const savedPage = loadValue("poll-form", "page") || 0;
    const realFormPage = store.getState().poll.page || 0;
    // console.log("prev saved page: " + savedPage);
    // console.log("prev real page: " + realFormPage);
    if (savedPage !== realFormPage) {
      saveValue("poll-form", "page", 0);
      window.location.reload();
    } else {
      if ((store.getState().poll.page || 0) === 0)
        forEach(store.getState().form.pollForm.fields, (vValue, vKey) => {
          dispatch(untouch("pollForm", vKey));
        });
      dispatch({
        type: PREVIOUS_POLL_PAGE,
        values,
        history
      });
    }
    if (realFormPage > 0) saveValue("poll-form", "page", realFormPage - 1);

    window.scrollTo(0, 0);
  };
}
export function cancelConfirmDialog() {
  return {
    type: CANCEL_CONFIRM_DIALOG
  };
}

export function closeSavingErrorDialog() {
  return {
    type: CLOSE_SAVE_ERROR_DIALOG
  };
}
export function sendForm() {
  return {
    type: SEND_FORM
  };
}
export function realSendPoll(history, values) {
  const valuesToSend = Object.assign(values);
  // if (
  //   valuesToSend.ankieta_skadInfo &&
  //   valuesToSend.ankieta_skadInfo === "other" &&
  //   valuesToSend.ankieta_skadInfo_inne
  // )
  //   valuesToSend.ankieta_skadInfo = valuesToSend.ankieta_skadInfo_inne;
  if (
    valuesToSend.respondent_miasto &&
    valuesToSend.respondent_miasto === "other" &&
    valuesToSend.respondent_miasto_inne
  )
    valuesToSend.respondent_miasto = valuesToSend.respondent_miasto_inne;
  return dispatch => {
    axios
      .post("/api/poll", values)
      .then(response => {
        const { data } = response;
        if (data && data.result && data.result.success) {
          dispatch({ type: POLL_PROPERLY_SAVED, clear: true });
          history.push("/koniec");
        } else {
          //console.log(data);
          dispatch({ type: POLL_NOT_PROPERLY_SAVED });
        }
      })
      .catch(() => {
        // console.log(error);
        dispatch({ type: POLL_NOT_PROPERLY_SAVED });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/poll.js